/**
 * Notification Error Banner
 *
 * Shows when a notification channel has been disabled due to errors.
 * Guides users to fix the issue via the settings page.
 */
import { Alert, Button, Group, Text, Stack } from '@mantine/core';
import { IconAlertTriangle, IconMail, IconBrandTelegram } from '@tabler/icons-react';
import { useNotificationPreferences } from '@/hooks/useNotificationPreferences';
import { Link } from 'react-router-dom';

export function NotificationErrorBanner() {
  const { data: preferences } = useNotificationPreferences();

  if (!preferences) return null;

  const emailError = !preferences.email_enabled && preferences.email_error_message;
  const telegramError = !preferences.telegram_enabled && preferences.telegram_error_message;

  if (!emailError && !telegramError) return null;

  return (
    <Alert
      icon={<IconAlertTriangle size={20} />}
      color="orange"
      variant="light"
      mb="md"
    >
      <Stack gap="xs">
        {emailError && (
          <Group gap="xs" wrap="nowrap">
            <IconMail size={16} />
            <Text size="sm" style={{ flex: 1 }}>
              Email notifications are disabled. We couldn&apos;t deliver to your email address.
            </Text>
            <Button
              component={Link}
              to="/settings?tab=notifications"
              size="xs"
              variant="subtle"
            >
              Fix in Settings
            </Button>
          </Group>
        )}

        {telegramError && (
          <Group gap="xs" wrap="nowrap">
            <IconBrandTelegram size={16} />
            <Text size="sm" style={{ flex: 1 }}>
              Telegram notifications are disabled. You may have blocked the bot.
            </Text>
            <Button
              component={Link}
              to="/settings?tab=notifications"
              size="xs"
              variant="subtle"
            >
              Reconnect
            </Button>
          </Group>
        )}
      </Stack>
    </Alert>
  );
};
